export default class DtoPiezometerChartLandmarks {
    constructor(object) {
        this.id = object.id
        this.lastLandmark = object.lastlandmark
        this.groundRefAlti = object.groundRefAlti
    }
}